import React from "react";

import { MdArrowForwardIos, MdArrowBackIos } from "react-icons/md";

export function Pagination(props) {
  const { size = "[30px]", position = "justify-center" } = props;
  return (
    <nav
      className={`flex items-center gap-1 w-full ${position}`}
      aria-label="Pagination Navigation"
    >
      <button
        className={`w-${size} h-${size} text-center border border-[#dddddd] cursor-pointer`}
        onClick={props.onFirstClick}
      >
        <div className="flex justify-center items-center">
          <MdArrowBackIos className="-mr-[4px] " />
          <MdArrowBackIos className="-ml-[4px] " />
        </div>
      </button>
      <button
        className={`w-${size} h-${size} text-center p-2 border border-[#dddddd] cursor-pointer`}
        onClick={props.onPrevClick}
      >
        <MdArrowBackIos className="m-auto" />
      </button>

      <ol className="flex gap-1 max-w-[400px] overflow-auto no-scrollbar">
        {Array(props.total)
          .fill(0)
          .map((_, index) => {
            const value = index + 1;
            const isCurrentPage = index === props.page;

            return (
              <li
                className={`flex-none w-${size} h-${size} text-center p-1 border border-[#dddddd] cursor-pointer ${
                  isCurrentPage ? "bg-primary-blue text-white" : ""
                }`}
                key={value}
              >
                <div className="m-auto" onClick={() => props.onChange?.(index)}>
                  {value}
                </div>
              </li>
            );
          })}
      </ol>

      <button
        className="w-[30px] h-[30px] text-center p-2 border border-[#dddddd] cursor-pointer"
        onClick={props.onNextClick}
      >
        <MdArrowForwardIos className="m-auto" />
      </button>

      <button
        className="w-[30px] h-[30px] text-center border border-[#dddddd] cursor-pointer"
        onClick={props.onLastClick}
      >
        <div className="flex justify-center items-center">
          <MdArrowForwardIos className="-mr-[4px] " />
          <MdArrowForwardIos className="-ml-[4px] " />
        </div>
      </button>
    </nav>
  );
}
